import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';

const AiPerformanceRunsPage = lazy(
  () => import('~/features/ai-performance/pages/ai-performance-runs-page'),
);

/**
 * AI Performance landing page — the run picker. Insights are scoped to one enrichment
 * run, so this is where the `$workflowId` the dashboard needs actually comes from.
 */
export const Route = createFileRoute('/_authenticated/_tenant/ai-performance/')({
  component: () => (
    <Suspense fallback={<PageSkeleton />}>
      <AiPerformanceRunsPage />
    </Suspense>
  ),
});
